<div class="SideTabs" [class.active]="active" [class.last]="last">
    <svg class="SideTabs-icon">
      <use attr.xlink:href="assets/sprites/sprite.svg#{{icon}}" xlink:href=""/>
    </svg>
    <p class="SideTabs-title">{{title}}</p>
</div>
